// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l2GwXVmvAjSHXo6PPZUM{margin-top:32px}`, "",{"version":3,"sources":["webpack://./src/entities/Phone/ui/actions/assignInbox/ui/ui/AssignInboxTwilioVendor/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA","sourcesContent":[".wrapBillingInfo {\n  margin-top: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapBillingInfo": `l2GwXVmvAjSHXo6PPZUM`
};
export default ___CSS_LOADER_EXPORT___;
